<template>
	<v-container fill-height fluid>
		<v-row align="center" justify="center">
			<v-col cols="11" sm="9" md="6" lg="5">
				<h1 class="display-1 font-weight-black font-italic primary--text my-8">Новий пароль</h1>
				<v-alert v-if="invalidLink" type="warning" text role="alert">
					Посилання недійсне або термін його дії минув. Запроси новий лист.
				</v-alert>
				<template v-else>
					<p>Установи новий пароль для {{ email }}. Після зміни потрібно буде знову увійти на своїх пристроях.</p>
					<v-alert v-if="error" type="error" text role="alert">{{ error }}</v-alert>
					<v-form ref="form" @submit.prevent="submit">
						<v-text-field
							v-model="password"
							label="Новий пароль"
							name="password"
							type="password"
							autocomplete="new-password"
							:rules="passwordRules"
							:disabled="loading"
							maxlength="255"
							hint="Щонайменше 8 символів"
							persistent-hint
							required />
						<v-text-field
							v-model="confirmation"
							label="Повтори новий пароль"
							name="password_confirmation"
							type="password"
							autocomplete="new-password"
							:rules="[value => value === password && !!value || 'Паролі мають збігатися']"
							:disabled="loading"
							maxlength="255"
							required />
						<v-btn type="submit" color="btnBg" class="btnTxt--text my-4" :loading="loading" :disabled="loading">
							Зберегти новий пароль
						</v-btn>
					</v-form>
				</template>
				<p class="mt-4"><router-link :to="{ name: 'forgot-password', query: { email } }">Запросити нове посилання</router-link></p>
				<p><router-link :to="{ name: 'login' }">Повернутися до входу</router-link></p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import authApi from '../../api/authApi'
import { clearSession } from '../../api/authSession'

export default {
	data() {
		const { token, email } = this.$route.query
		return {
			token: typeof token === 'string' ? token : '',
			email: typeof email === 'string' ? email : '',
			password: '',
			confirmation: '',
			loading: false,
			invalidLink: typeof token !== 'string' || !token || typeof email !== 'string' || !email,
			error: '',
			passwordRules: [value => value.length >= 8 || 'Пароль має містити щонайменше 8 символів'],
		}
	},
	methods: {
		async submit() {
			if (this.loading || this.invalidLink || !this.$refs.form.validate()) return
			this.loading = true
			this.error = ''
			try {
				await authApi.resetPassword({
					token: this.token,
					email: this.email,
					password: this.password,
					password_confirmation: this.confirmation,
				})
				clearSession()
				this.password = ''
				this.confirmation = ''
				this.token = ''
				await this.$router.replace({ name: 'login', query: { passwordReset: '1' } })
			} catch (error) {
				const response = error.response || {}
				if (response.data && response.data.code === 'password_reset_invalid') {
					this.invalidLink = true
				} else if (response.status === 429) {
					this.error = 'Забагато спроб. Зачекай хвилину й повтори.'
				} else if (response.status === 422) {
					this.error = 'Перевір пароль і його підтвердження.'
				} else {
					this.error = 'Не вдалося змінити пароль. Перевір з’єднання та спробуй ще раз.'
				}
			} finally {
				this.loading = false
			}
		},
	},
}
</script>
